(function () {
  function initBlock(block) {
    var buttons = block.querySelectorAll('.svd-tabs__btn');
    var panels  = block.querySelectorAll('.svd-tabs__panel');

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.getAttribute('data-tab');
        buttons.forEach(function (b) { b.classList.remove('is-active'); b.setAttribute('aria-selected', 'false'); });
        panels.forEach(function (p) { p.classList.remove('is-visible'); });
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');
        var panel = block.querySelector('[data-panel="' + target + '"]');
        if (panel) panel.classList.add('is-visible');
      });
    });
  }

  function init() { document.querySelectorAll('.svd-tabs-block').forEach(initBlock); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
